import { CampusPageExerciseEditChemistryFormula } from './campus-page-exercise-edit-chemistry-formular.js';
import { CampusPageExerciseEditGeogebra } from './campus-page-exercise-edit-geogebra.js';
import { CampusPageExerciseEditH5P } from './campus-page-exercise-edit-h5p.js';
import {
  CampusPageExerciseEditLEVUMIGerman,
  CampusPageExerciseEditLEVUMIMath,
  CampusPageExerciseEditLEVUMINumberDictate,
} from './campus-page-exercise-edit-levumi.js';
import { CampusPageExerciseEditSerloEditor } from './campus-page-exercise-edit-serlo-editor.js';
import { CampusPageExerciseEditSerlo } from './campus-page-exercise-edit-serlo.js';
import { CampusPageExerciseEditText } from './campus-page-exercise-edit-text.js';

/**
 * All exercise edit/create pages that are available in the campus.
 */
export const ALL_EXERCIE_PAGES = {
  [CampusPageExerciseEditText.exerciseType]: CampusPageExerciseEditText,
  [CampusPageExerciseEditChemistryFormula.exerciseType]: CampusPageExerciseEditChemistryFormula,
  [CampusPageExerciseEditGeogebra.exerciseType]: CampusPageExerciseEditGeogebra,
  [CampusPageExerciseEditH5P.exerciseType]: CampusPageExerciseEditH5P,
  [CampusPageExerciseEditSerlo.exerciseType]: CampusPageExerciseEditSerlo,
  [CampusPageExerciseEditSerloEditor.exerciseType]: CampusPageExerciseEditSerloEditor,
  [CampusPageExerciseEditLEVUMIGerman.exerciseType]: CampusPageExerciseEditLEVUMIGerman,
  [CampusPageExerciseEditLEVUMIMath.exerciseType]: CampusPageExerciseEditLEVUMIMath,
  [CampusPageExerciseEditLEVUMINumberDictate.exerciseType]: CampusPageExerciseEditLEVUMINumberDictate,
};
